// translations/blog.ts
export const translations = {
  en: {
    'blog.title': 'Blog',
    'blog.description': 'Stay updated with the latest news, guides, and tips about invoice conversion, XRechnung, and e-invoicing compliance.',
    'blog.heading': 'Latest Updates &',
    'blog.headingHighlight': 'Guides',
    'blog.pageTitle': 'Blog - Latest Updates & Guides',
    'blog.metaDescription': 'Stay updated with the latest news, guides, and tips about invoice conversion, XRechnung, and e-invoicing compliance.',
    'blog.readMore': 'Read more',
    'blog.locale': 'en-US',
  },
  de: {
    'blog.title': 'Blog',
    'blog.description': 'Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten, Anleitungen und Tipps zu Rechnungskonvertierung, XRechnung und E-Rechnungs-Compliance.',
    'blog.heading': 'Neueste Updates &',
    'blog.headingHighlight': 'Anleitungen',
    'blog.pageTitle': 'Blog - Neueste Updates & Anleitungen',
    'blog.metaDescription': 'Bleiben Sie auf dem Laufenden mit den neuesten Nachrichten, Anleitungen und Tipps zu Rechnungskonvertierung, XRechnung und E-Rechnungs-Compliance.',
    'blog.readMore': 'Weiterlesen',
    'blog.locale': 'de-DE',
  },
};